var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "password-login-form"
  }, [_c('div', {}, [_c('div', {
    staticClass: "left-login"
  }, [_c('div', {
    staticClass: "rep-icon-login"
  }, [_c('router-link', {
    staticClass: "ms-0 ps-0 login-highlight back-btn-pwd",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Back")]), _c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard-rep.svg"),
      "alt": "image-fluid"
    }
  })], 1), _c('div', {}, [_c('router-link', {
    attrs: {
      "to": "/smart-login"
    }
  }, [_c('button', {
    staticClass: "qr-login-btn"
  }, [_c('img', {
    staticClass: "me-2",
    attrs: {
      "src": require("../../assets/images/qr-icon.svg"),
      "alt": "qr icon"
    }
  }), _vm._v("Login with QR ")])])], 1)])]), _c('h4', {
    staticClass: "login-title mb-0"
  }, [_vm._v("Login to Continue")]), _c('div', {
    staticClass: "auth-form pt-3 pb-3"
  }, [_c('div', {
    staticClass: "email-change-wrap"
  }, [_c('div', {}, [_vm._v(_vm._s(_vm.repEmail))]), _c('div', {
    staticClass: "login-highlight",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Change")])]), _c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.handleLogin);
            }
          }
        }, [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Password"), _c('span', {
          staticClass: "required-label mt-2"
        }, [_vm._v("*")])]), _c('div', {
          staticClass: "login-password-container"
        }, [_c('custom-input-text', {
          attrs: {
            "rules": {
              required: true
            },
            "customMessages": "Please enter your password",
            "labelFor": "",
            "labelName": "Password",
            "placeholder": "Please enter your password",
            "inputType": _vm.passwordType,
            "formGroupClass": "form-group mb-1",
            "isErrorFlagSet": _vm.passwordErrorFlag,
            "vmodel": _vm.password
          },
          on: {
            "emitChanges": _vm.resetErrorMsg,
            "update:vmodel": function updateVmodel($event) {
              _vm.password = $event;
            }
          }
        }), _c('eye-button', {
          staticClass: "login-toggle-eye-icon",
          attrs: {
            "id": "password",
            "hideOnDefault": "false",
            "value": _vm.password,
            "type": "text"
          },
          on: {
            "toggle": _vm.togglePasswordVisibility
          }
        }), _vm.passwordErrorFlag ? _c('div', {
          staticClass: "valid-error"
        }, [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]) : _vm._e()], 1), _c('button', {
          staticClass: "submit-btn mt-3 next-btn",
          attrs: {
            "disabled": _vm.loginLoader || _vm.lockoutTime > 0,
            "type": "submit"
          }
        }, [_vm.loginLoader ? _c('b-spinner', {
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" Login ")], 1)])];
      }
    }])
  }), _vm.lockoutTime > 0 ? _c('lockout-timer', {
    attrs: {
      "lockout-seconds": _vm.lockoutTime
    },
    on: {
      "lockout-expired": _vm.handleLockoutExpired
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "left-login mb-0"
  }, [_c('div'), _c('router-link', {
    attrs: {
      "to": "/forgot-password"
    }
  }, [_c('div', {
    staticClass: "login-highlight"
  }, [_vm._v("Forgot Password?")])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }